import http from '@/helpers/Http';

export default {
    namespaced: true,
    state: {
        items: {
            data: [],
            meta: {},
            links: {},
        },
        item: {},
    },
    getters: {
        items: state => state.items,
        item: state => state.item,
    },
    mutations: {
        setItems(state, items) {
            state.items = items;
        },
        setItem(state, item) {
            state.item = item;
        }
    },
    actions: {
        async index({ commit, rootState }) {
            const response = await http.get('admin/permissions', {params: rootState.route.query});

            commit('setItems', response.data);

            return response;
        },
        async store({ commit }, payload) {
            const response = await http.post('admin/permissions', payload);

            return response;
        },
        async update({ commit }, payload) {
            const response = await http.patch(`admin/permissions/${payload.id}`, payload);

            return response;
        },
        async delete({ commit }, id) {
            const response = await http.delete(`admin/permissions/${id}`);

            return response;
        }
    }
}